import React from "react";
import route from "../../../Route.json";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      <div className="sidebar p-3 bg-primary">
        <div className="logo-side">
          <Image
            src="/images/timba.png"
            alt="olade logo"
            className="img-fluid"
          />
        </div>
        <ul className="nav flex-column">
          {route.map((item, index) => (
            <li className="nav-item" key={index}>
              <Link
                to={`/${item.link}`}
                className={`nav-link ${
                  pathname === `/${item.link}` ? "active" : ""
                }`}
              >
                <i className={`${item["bi-icon"]} pe-2`}></i> {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
